import React, { useState, useLayoutEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import backgroundImage from '../assets/background.png';
import '../css/pages_styles.css';

const Sponsorship = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useLayoutEffect(() => {
        const mq = window.matchMedia('(max-width: 768px)');
        const handler = (e) => {
            const mobile = e.matches;
            setIsMobile(mobile);
            // 在手機版時，初始設定 sidebar 為收起狀態
            if (mobile) {
                setSidebarExpanded(false);
            }
        };

        // 初始設定
        handler(mq);

        // 監聽變化
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    >
                        <h1 className="title">贊助辦法</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>      
                        <div className={`scroll-hint ${isMobile ? 'scroll-hint-mobile' : ''}`}>
                            ← 左右滑動查看完整表格 →
                        </div>              
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th">等級標誌</th>
                                        <th className="th">鑽石級</th>
                                        <th className="th">白金級</th>
                                        <th className="th">金級</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="td">贊助金額</td>
                                        <td className="td">NT$50,000</td>
                                        <td className="td">NT$30,000</td>
                                        <td className="td">NT$15,000</td>
                                    </tr>
                                    <tr>
                                        <td className="td">大會列名</td>
                                        <td className="td">主要贊助商</td>
                                        <td className="td">主要贊助商</td>
                                        <td className="td">贊助商</td>
                                    </tr>
                                    <tr>
                                        <td className="td">專題演講</td>
                                        <td className="td">50 分鐘<br/>(技術內容為主，可輔以公司介紹)</td>
                                        <td className="td" rowSpan={2}>
                                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                                二擇一<br/>
                                                50 分鐘（技術內容為主，可輔以公司介紹）<br/>
                                                1 天
                                            </div>
                                        </td>
                                        <td className="td" rowSpan={2}>無</td>
                                    </tr>
                                    <tr>
                                        <td className="td">攤位數量</td>
                                        <td className="td">1 天</td>
                                    </tr>
                                    <tr>
                                        <td className="td">廣告文宣</td>
                                        <td className="td" colSpan="3">
                                            1. 隨資料袋發送 (A4×3)<br/>
                                            2. 主要品牌 LOGO 置於會場及研討會網站
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="td">晚宴券</td>
                                        <td className="td">4 張</td>
                                        <td className="td">2 張</td>
                                        <td className="td">1 張</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="sponsor-info">
                            <p><strong>地點：</strong>集思台大會議中心</p>
                            <p><strong>大會將提供贊助廠商優先參與廠商技術研討、產品發表之權利。</strong></p>
                            <p className="note">※備註：大會對本贊助辦法之各項內容保留最後決定權。</p>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Sponsorship;